(function($) {
  "use strict";

  $(window).ready(listOffre);

  // Constants
  var select = "#views-exposed-form-liste-offre-de-poste-page-1 select";
  var input = "#views-exposed-form-liste-offre-de-poste-page-1 input";

  /**
   * Init
   */
  function listOffre() {

      $('body').on("change", select, function (e) {
          jQuery(input).click();
      });

  }

})(jQuery);